import React from 'react';
import { Box, Text } from '../core';
import { formatPercentage, formatDollars, DataType } from '@sc1/common/utils';

export interface ILegend {
  label: string | JSX.Element;
  value: string;
  color: string;
}

export function fmtLegendValue(dataType: DataType, value) {
  if (value == null || dataType == null) return '';
  switch (dataType) {
    case 'price':
      return formatDollars(value);
    case 'yield':
    case 'volatility':
      return formatPercentage(value / 100);
    default:
      return value;
  }
}

export const Legends = ({ legends }: { legends?: ILegend[] }) =>
  legends?.length ? (
    <Box sx={{ position: 'absolute', top: 1, left: 80, zIndex: 2 }}>
      {legends?.map(({ label, value, color }) => (
        <Box key={label + color}>
          <Text>{label}: </Text>
          <Text color={color}>{value}</Text>
        </Box>
      ))}
    </Box>
  ) : null;
